import { Nullable } from "../../base-types";
import Guard from "../../guard";
import { IEntity } from "../base";
import { ISearchAfterResult, SearchAfterResultBase } from "./search-after-result";

export type IEntitySearchAfterResult = ISearchAfterResult<IEntity>;

export class EntitySearchAfterResult extends SearchAfterResultBase<IEntity> {
    items: Array<IEntity>;

    constructor(
        entities: Array<IEntity>,
        totalItems: number,
        returnedItems: number,
        lastHitData?: Nullable<Array<string>>
    ) {
        super(totalItems, returnedItems, lastHitData);

        Guard.notNullOrUndefined(entities);

        this.items = [...entities];
    }
}
